import GPSinaLogoGrey from '../../src/assets/images/logo/logo-small-gray.png';
import XTrackLogo from '../../src/assets/images/logo/logo-small.png';
import SoundStreamLogo from '../../src/assets/images/logo/ss_small.png';
import SoundStreamDarkLogo from '../../src/assets/images/logo/SS_dark_logo.png';

const APP_LOGO=[GPSinaLogoGrey,XTrackLogo,SoundStreamLogo,SoundStreamDarkLogo]
const GPSina = 0;
const XTrack = 1;
const StarTrack = 2;
const SoundStream = 3;

const APPLICATIONS = {
  [GPSina]: "GPSina",
  [XTrack]: "XTrack",
  [StarTrack]: "StarTrack",
  [SoundStream]: "SoundStream",
}

const APPS_VERSION = {
  0: '3.0.21',
  1: '3.0.13',
  2: '3.0.0',
  3: '3.0.0'
}

const APP_TYPE = GPSina ;
;

const Config = {
  // et_api_url: 'https://mobile.ehub66.com:8088/api/',
  // et_socket_url: 'wss://msk3.gpsina.com:8001',

  et_api_url: 'https://api2tt.gpsina.com/',
  et_socket_url: 'wss://mobilecommunicator.gpsina.com:8000',
  installer_api_url: 'https://installer-app.gpsina.com/',
  googleApiKey: "AIzaSyCXpBbmHe03lJIZq2FmzR51YeniR1dsBgs",
  salt: "passphrasewhichneedstobe32bytes!",
  notificationDaysBeforeDeviceExpire: 30,
  version: "1.1.5",
  appVersion: APPS_VERSION[APP_TYPE],
  logsDisable: true,
  appType: APP_TYPE,
  applicationName: APPLICATIONS[APP_TYPE],
  userType: 0,
  appLogo:APP_LOGO,
};

export default Config;